import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selfShape } from '../../utils/propTypes';
import { submitFeedback, clearFeedback } from './supportActions';
import {
    getFeedbackSubmitErrorMessage,
    getIsFeedbackSubmitSuccessful,
    getIsFeedbackSubmitSending
} from './supportEntity';
import { getCustomAccess, getSelf } from '../Self/selfEntity';
import { toastIfError } from '../../utils/toast';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import mixpanel from '../../utils/mixpanel';
import {
    EmvioCard,
    EmvioRow
} from '@nexio/emvio-util-ui';
import {
    EmvioValidatedForm,
    EmvioValidatedButton,
    EmvioValidatedTextArea
} from '@nexio/emvio-form-components';
import './Support.scss';
import { getMerchants } from '../Merchants/merchantsEntity';
import classNames from 'classnames';
import { doesRoleHaveAccessToFeature } from '../../utils/customRole';
import config from '../../config/config';

export class Support extends Component {
    static propTypes = {
        error: PropTypes.string,
        isSending: PropTypes.bool,
        onClose: PropTypes.func,
        onSubmit: PropTypes.func,
        self: selfShape,
        success: PropTypes.bool,
        merchants: PropTypes.array,
        customAccess: PropTypes.any
    };

    constructor(props) {
        super(props);
        this.state = {
            feedback: '',
            halfWidth: true
        };
    }

    componentDidMount() {
        mixpanel.track('Support Page mounted');
    }

    componentWillUnmount() {
        this.props.onClose();
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props);
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'success')) {
            this.setState({ feedback: '' });
        }
    }

    updateFeedbackText = (e) => {
        this.setState({
            feedback: e.target.value
        });
    };

    submitFeedback = (e) => {
        e.preventDefault();
        this.props.onSubmit(this.state.feedback, this.props.self, this.props.merchants);
    };

    renderForm = () => {
        return (
            <EmvioValidatedForm className="feedback-form" onSubmit={this.submitFeedback}>
                <span className="emvio-bold">Email Support</span><br />
                <EmvioValidatedTextArea
                    labelText="Please let us know if you have any questions, comments, or concerns."
                    name="feedbackTexarea"
                    onChange={this.updateFeedbackText}
                    validations={['required']}
                    value={this.state.feedback}
                />
                <EmvioValidatedButton
                    isLoading={this.props.isSending}
                    invertColors>
                    Send
                </EmvioValidatedButton>
            </EmvioValidatedForm>
        );
    };

    renderFAQForm = () => {
        return (
            <EmvioValidatedForm className="frequently-asked-questions-form">
                <span className="emvio-bold">Frequently Asked Questions</span><br /><br />
                <a href={'https://completemerchantsolutions.freshdesk.com/support/solutions/articles/36000129034-nexio-reset-password'} rel="noopener noreferrer" target="_blank">
                    <span className="emvio-blue">How do I reset my Nexio dashboard password?</span><br /><br /></a>
                <a href={'https://completemerchantsolutions.freshdesk.com/support/solutions/articles/36000129036-chargeback-tool-introduction'} rel="noopener noreferrer" target="_blank">
                    <span className="emvio-blue">Can you tell me about the Chargeback tab?</span><br /><br /></a>
                <a href={'https://completemerchantsolutions.freshdesk.com/support/solutions/articles/36000108297-nexio-transactions-video'} rel="noopener noreferrer" target="_blank">
                    <span className="emvio-blue">Can you tell me about the Transactions tab?</span><br /><br /></a>
                <a href={'https://completemerchantsolutions.freshdesk.com/support/solutions/articles/36000130566-kount-introduction'} rel="noopener noreferrer" target="_blank">
                    <span className="emvio-blue">How can I prevent fraud using Nexio&apos;s APIs?</span><br /><br /></a>
                <a href={'https://completemerchantsolutions.freshdesk.com/support/solutions/articles/36000108301-nexio-deposit-summary'} rel="noopener noreferrer" target="_blank">
                    <span className="emvio-blue">Can you tell me about the Deposit Summary tab?</span>
                    <br /><br /></a>
                <a href={'https://completemerchantsolutions.freshdesk.com/support/home'} rel="noopener noreferrer" target="_blank">
                    <span>More questions?</span> <span className="emvio-blue">Search our Knowledge Base!</span><br /><br /><br /></a>
                <span>To speak with a customer support agent call 1-877-267-4324.</span>
            </EmvioValidatedForm>
        );
    };

    renderStatusCheck = () => {
        return (
            <EmvioValidatedForm className="frequently-asked-questions-form">
                <span className="emvio-bold">Nexio Status Check</span><br /><br />
                <a href={'https://status.nexiopay.com/'} rel="noopener noreferrer" target="_blank">
                    <span className="emvio-blue">Check the status of the Nexio APIs</span><br /></a>
            </EmvioValidatedForm>
        );
    };

    renderSuccess = () => {
        return (
            <div className="success-card">
                <div className="success-message">
                    <div>Your email to support has been sent successfully</div>
                </div>
                <p className="success-link" onClick={this.props.onClose}>
                    Click here to send another email
                </p>
            </div>
        );
    };

    render() {
        const doesHaveAccessToFeedbackCard = doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.email]: ['POST/v3/feedback'] });
        const halfWidthContainerClassName = classNames('grow-height', {
            'half-width': this.state.halfWidth
        });
        const fullWidthContainerClassName = classNames('grow-height', {
            'full-width': !this.state.halfWidth
        });

        return (
            <div className="emvio-support">
                <EmvioRow className="emvio-support">
                    <EmvioCard className={doesHaveAccessToFeedbackCard
                        ? halfWidthContainerClassName : fullWidthContainerClassName}>
                        {this.renderFAQForm()}
                    </EmvioCard>
                    {doesHaveAccessToFeedbackCard
                        ? <EmvioCard className="grow-height half-width feedback-card">
                            {this.props.success ? this.renderSuccess() : this.renderForm()}
                        </EmvioCard> : null}
                </EmvioRow>
                <EmvioRow className="emvio-support">
                    <EmvioCard className={doesHaveAccessToFeedbackCard
                        ? halfWidthContainerClassName : fullWidthContainerClassName}>
                        {this.renderStatusCheck()}
                    </EmvioCard>
                </EmvioRow>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        error: getFeedbackSubmitErrorMessage(state),
        isSending: getIsFeedbackSubmitSending(state),
        self: getSelf(state),
        success: getIsFeedbackSubmitSuccessful(state),
        merchants: getMerchants(state),
        customAccess: getCustomAccess(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onClose: () => dispatch(clearFeedback()),
        onSubmit: (feedback, self, merchants) => dispatch(submitFeedback(feedback, self, merchants))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Support);
